<script lang="ts">
import { defineComponent } from 'vue';
import CustomSelect from '@/components/custom-select.vue';
import { useSportsStore } from '@/stores/sports';
import { mapState } from 'pinia';
import { catchError } from '@/helpers/toast';
import { fetchCompetitions, fetchRegions } from '@/api/admin-be';
import { usePoolsStore } from '@/stores/pools';

export default defineComponent({
  name: 'event-filters',
  components: { CustomSelect },
  computed: {
    ...mapState(useSportsStore, ['sports']),
    ...mapState(usePoolsStore, ['currentPoolId', 'pools']),
    filterSportId: {
      get() {
        return this.sportId;
      },
      set(v) {
        this.$emit('update:sportId', v);
        if (v) {
          fetchRegions({ sportId: v })
            .then((res) => {
              this.regions = res;
              this.competitions = null;
              this.filterRegionId = null;
              this.filterCompetitionId = null;
            })
            .catch((error) => catchError('Ошибка загрузки регионов', error));
        }
      },
    },
    filterRegionId: {
      get() {
        return this.regionId;
      },
      set(v) {
        this.$emit('update:regionId', v);
        if (v) {
          fetchCompetitions({ sportId: this.filterSportId, regionId: v })
            .then((res) => {
              this.competitions = res;
              this.filterCompetitionId = null;
            })
            .catch((error) => catchError('Ошибка загрузки турниров', error));
        }
      },
    },
    filterCompetitionId: {
      get() {
        return this.competitionId;
      },
      set(v) {
        this.$emit('update:competitionId', v);
      },
    },
    startDate: {
      get() {
        return this.fromDate;
      },
      set(v) {
        this.$emit('update:fromDate', v);
      },
    },
    endDate: {
      get() {
        return this.toDate;
      },
      set(v) {
        this.$emit('update:toDate', v);
      },
    },
    filterDiff: {
      get() {
        return this.inputDiff?.toString();
      },
      set(v) {
        this.$emit('update:inputDiff', +v || null);
      },
    },
  },
  data() {
    return {
      regions: null,
      competitions: null,
    };
  },
  emits: [
    'update:sportId',
    'update:regionId',
    'update:competitionId',
    'update:fromDate',
    'update:toDate',
    'update:inputDiff',
  ],
  props: ['sportId', 'regionId', 'competitionId', 'fromDate', 'toDate', 'inputDiff'],
  watch: {
    currentPoolId(v) {
      if (v && this.pools) {
        const pool = this.pools.find((c: { id: number }) => c.id === v);
        this.startDate = new Date(pool.endBetAt || pool.startBetAt);
      }
    },
  },
});
</script>

<template>
  <div class="flex gap-1 my-2">
    <span class="my-2 text-sm">
      <DatePicker
        v-model="startDate"
        show-icon
        show-time
        fluid
        :min-date="new Date()"
        icon-display="input"
        placeholder="Начало"
        date-format="dd.mm.yy"
      />
    </span>
    <span class="my-2 text-sm">
      <DatePicker
        v-model="endDate"
        show-icon
        show-time
        :min-date="fromDate"
        fluid
        icon-display="input"
        placeholder="Конец"
        date-format="dd.mm.yy"
      />
    </span>
    <custom-select
      :options="sports"
      v-model="filterSportId"
      placeholder="Выберите спорт..."
      labelName="name"
    />
    <custom-select
      v-if="regions"
      :options="regions"
      v-model="filterRegionId"
      value-name="id"
      label-name="name"
      placeholder="Выберите регион..."
    />
    <custom-select
      v-if="competitions"
      :options="competitions"
      v-model="filterCompetitionId"
      value-name="id"
      label-name="name"
      placeholder="Выберите турнир..."
    />
    <InputText type="number" v-model="filterDiff" placeholder="Разница %" class="my-1" />
  </div>
</template>

<style scoped lang="scss"></style>
